var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.pageReady)?_c('div',[(_vm.activityDefinition.version == 'v1')?_c('div',[_c('DashboardView')],1):_c('div',[_c('authentication-interceptor',[_c('accept-policies-interceptor',[_c('detail-component-dashboard',{attrs:{"detail-definition-id":_vm.dashboardDefinitionId}})],1)],1)],1)]):_c('div',[_c('loader')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }